export default __webpack_public_path__ + "static/media/placeholder_business03-jp-web.2f96dacb.png";